import { render, staticRenderFns } from "./GHGITreeMap.vue?vue&type=template&id=53595ac0"
import script from "./GHGITreeMap.vue?vue&type=script&lang=js"
export * from "./GHGITreeMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports